import React, {
  ChangeEvent,
  FocusEvent,
  RefObject,
} from 'react';

import { StyledInput } from './styles';

interface IInputProps {
  className?: string;
  value: string;
  isInvalid?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  inputRef?: RefObject<HTMLInputElement>;
}

export const Input = ({
  className,
  value,
  isInvalid = false,
  disabled = false,
  placeholder,
  onChange,
  onBlur,
  inputRef,
}: IInputProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value.trimStart());
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (!onBlur) {
      return;
    }

    onBlur(event.target.value.trimStart());
  };

  return (
    <StyledInput
      className={className}
      ref={inputRef}
      value={value}
      placeholder={placeholder}
      isInvalid={isInvalid}
      disabled={disabled}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
